export enum PageType {
    ARTICLE = 'article',
    AUTHOR = 'author',
}
